<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="3">COBERTURAS</th>
      </tr>
      <tr>
        <td class="pl-3">
          <b>Cobertura</b>
        </td>
        <td class="pl-3">
          <b>Limite Máximo Indenização</b>
        </td>
        <td class="pl-3">
          <b>Prêmio Líquido</b>
        </td>
      </tr>
      <tr v-for="(item, index) in selectedCoverage" :key="index">
        <td class="pl-3">
          {{ item.productName }}
        </td>
        <td class="pl-3">
          {{ getFormattedItemLmi(item) }}
        </td>
        <td class="pl-3">
          {{
            !isEndorsementWithCalculation ||
            (prizeData && prizeData.prize === 0)
              ? 'R$ 0,00'
              : functions.formataReal(item.values.originalValue)
          }}
        </td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.COVERAGES"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.COVERAGES"
    ></div>
  </vx-card>
</template>

<script>
import { getFormattedItemLmi } from '../../../services/contract';
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractProducts',
  props: {
    isEndorsementWithCalculation: {
      type: Boolean,
      required: true,
      default: false,
    },
    selectedCoverage: {
      type: Array,
      required: true,
      default: () => [],
    },
    prizeData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      functions,
      getFormattedItemLmi,
    };
  },
};
</script>
